import React, { useState } from "react";
import Layout from "../../layouts/Layout";
import HeadingWithBtns from "../../Components/Common/HeadingWithBtns";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";
import Heading from "../../Components/Common/Heading";
import ProfileCards from "../../Components/ExerciseCalendar/ProfileCards";
import AgendaCalendar from "../../Components/ExerciseCalendar/AgendaCalendar";
import EventDrawer from "../../Components/ExerciseCalendar/EventDrawer";
import { colors } from "../../theme/theme";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const ExerciseCalendar = () => {
  const location = useLocation();
  const visitingId = location.state?.visitingId || null;
  const [drawerState, setDrawerState] = useState(false);
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const { userData } = useSelector((state) => state.user);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedRange, setSelectedRange] = useState("daily");
  const currentMonthYear = new Date().toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });
  };

  // Function to calculate the date range
  const getDateRange = (rangeType) => {
    const today = new Date();

    if (rangeType === "daily") {
      // Daily: 1-month range from today
      const startDate = new Date(today);
      startDate.setMonth(startDate.getMonth() - 1);

      const endDate = new Date(today);
      return `${formatDate(startDate)} - ${formatDate(endDate)}`;
    }

    if (rangeType === "weekly") {
      // Weekly: Range from the start to the end of the current week
      const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - dayOfWeek);

      const endOfWeek = new Date(today);
      endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));

      return `${formatDate(startOfWeek)} - ${formatDate(endOfWeek)}`;
    }

    if (rangeType === "monthly") {
      // Monthly: Range from the first to the last day of the current month
      const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      return `${formatDate(startOfMonth)} - ${formatDate(endOfMonth)}`;
    }

    return ""; // Fallback
  };
  return (
    <Layout>
      <HeadingWithBtns title="Training Hub" creator calendar />

      {smallScreen && (
        <Box
          sx={{
            width: "100%",
          }}
        >
          {/* Month Title */}
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: "600", // Fixed typo
              fontFamily: "Inter-Bold",
              color: colors.textColor,
              mb: 2,
            }}
          >
            {currentMonthYear}
          </Typography>

          {/* Tabs Section */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              m: 0,
              p: 0,
            }}
          >
            {/* Daily Tab */}
            <Box
              onClick={() => setSelectedRange("daily")}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                flex: 1,
                borderLeft: "1px solid black",
                borderTop: "1px solid",
                borderRight:
                  selectedRange === "daily"
                    ? "1px solid #FC0108"
                    : "1px solid black",
                borderTopColor: selectedRange === "daily" ? "#FC0108" : "black",
                borderLeftColor:
                  selectedRange === "daily" ? "#FC0108" : "black",
                p: 1,
                cursor: "pointer",
              }}
            >
              <Typography>Daily</Typography>
            </Box>

            {/* Weekly Tab */}
            <Box
              onClick={() => setSelectedRange("weekly")}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                flex: 1,
                borderLeft: "1px solid",
                borderTop: "1px solid",
                borderRight: "1px solid",
                borderRightColor:
                  selectedRange === "weekly" ? "#FC0108" : "black",
                borderTopColor:
                  selectedRange === "weekly" ? "#FC0108" : "black",
                borderLeftColor:
                  selectedRange === "weekly" ? "#FC0108" : "black",
                p: 1,
                cursor: "pointer",
              }}
            >
              <Typography>Weekly</Typography>
            </Box>

            {/* Monthly Tab */}
            <Box
              onClick={() => setSelectedRange("monthly")}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "row",
                flex: 1,
                borderTop: "1px solid",
                borderRight: "1px solid",
                borderTopColor:
                  selectedRange === "monthly" ? "#FC0108" : "black",
                borderRightColor:
                  selectedRange === "monthly" ? "#FC0108" : "black",
                p: 1,
                cursor: "pointer",
              }}
            >
              <Typography>Monthly</Typography>
            </Box>
          </Box>

          {/* Date Range Section */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start", // Fixed typo
              border: "1px solid black",
              width: "100%",
              p: 2,
              gap: 1,
            }}
          >
            <CalendarMonth />
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600", // Fixed typo
                fontFamily: "Inter-Bold",
                color: colors.textColor,
              }}
            >
              {getDateRange(selectedRange)} {/* Fixed variable reference */}
            </Typography>
          </Box>
        </Box>
      )}

      <Box sx={{ mt: 4 }}>
        {/* Agenda Calendar Section */}
        <AgendaCalendar
          drawerState={setDrawerState}
          selectedRange={selectedRange}
          userId={visitingId ? visitingId : userData?.id}
          setSelectedEvent={setSelectedEvent}
        />

        {/* Event Drawer Section */}
        <EventDrawer
          drawerState={drawerState}
          setDrawerState={setDrawerState}
          selectedEvent={selectedEvent}
        />
      </Box>
    </Layout>
  );
};

export default ExerciseCalendar;
